export const INJURY_PREVIEW_PAGE_TYPE = {
  APPROVALS: 'APPROVALS',
  CHILD: 'CHILD',
  INJURY: 'INJURY',
}
